import "@fontsource/noto-sans-jp"
import "./src/styles/base.css"
import "./src/styles/blog-contents-style.css"

// gatsby-browser.js

export const onRouteUpdate = () => {
  if (typeof document !== "undefined") {
    // ★ ここを修正：fadeInUp と slideInLeft の両方を監視
    const elements = document.querySelectorAll(".fadeInUp, .slideInLeft");

    const observer = new IntersectionObserver((entries) => {
      entries.forEach((entry) => {
        if (entry.isIntersecting) {
          entry.target.classList.add("appear");
        }
      });
    }, {
      threshold: 0.1,
    });

    elements.forEach((el) => observer.observe(el));

    return () => {
      elements.forEach((el) => observer.unobserve(el));
    };
  }
};
